<template>
  <div>
    <slot
      :file-index="fileIndex"
      :uploading="uploading"
      :errors="errors"
      :message="message"
      :retry="uploadAllFiles"
      :cancel="cancel"
      :percentage="percentage"
      :total="total"
      :uploaded="uploaded"
    />
  </div>
</template>

<script>
import FileUploader from '@/api/file-uploader';
import { requestQueue } from '@/api/api';

export default {
  name: 'ResumableUploadWrapper',
  props: {
    files: {
      type: Array,
      default: null,
    },
    uploadUrl: {
      type: [Function, String],
      required: true,
    },
  },
  data() {
    return {
      fileIndex: -1,
      uploader: null,
      uploading: false,
      percentage: 0,
      uploaded: 0,
      total: 0,
      message: '',
      errors: [],
    };
  },
  watch: {
    files: {
      immediate: true,
      handler(files) {
        if (!files?.length) {
          this.cancel();
          return;
        }

        this.uploadAllFiles();
      },
    },
  },
  methods: {
    async uploadAllFiles() {
      this.errors = [];
      this.message = '';

      const responses = [];

      try {
        for (let i = 0; i < this.files.length; i++) {
          const file = this.files[i];
          const uploadUrl = this.getUploadUrl(file);
          this.uploading = true;
          this.fileIndex = i;

          this.setupUploader(uploadUrl);
          const res = await this.upload(file);
          responses.push(res);
        }

        this.$emit('upload-done', responses, this.files);
      } catch ({ message, errors }) {
        this.message = message;
        this.$message.error(message);
        this.errors = errors || [];
      } finally {
        this.uploading = false;
      }
    },

    setupUploader(url) {
      if (this.uploader) this.uploader.abort();
      if (this.uploader?.url === url) return;

      this.uploader = new FileUploader({
        url,
        onProgress: (uploaded, total) => {
          this.uploaded = uploaded;
          this.total = total;
          this.percentage = Math.round((uploaded / total) * 100);
        },
      });
    },

    upload(file) {
      this.uploaded = 0;
      this.total = 0;
      this.percentage = 0;

      if (!this.uploader) return Promise.reject();

      return this.uploader.startUpload(file);
    },

    getUploadUrl(file) {
      if (typeof this.uploadUrl === 'function') {
        return this.uploadUrl(file);
      }

      return this.uploadUrl;
    },

    cancel() {
      this.uploading = false;
      this.errors = [];
      this.message = '';
      this.uploaded = 0;
      this.total = 0;
      this.percentage = 0;

      if (this.uploader) {
        this.uploader.abort();
        requestQueue.flush();
      }
    },
  },
};
</script>
